import React, { useState, useEffect } from 'react';


import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Box,
  Typography,
  InputAdornment,
  CircularProgress,
  Table,
  TextField,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Alert,
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  InputLabel
} from '@mui/material';
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from 'react-router-dom';

import { getAllDoctors } from "../../service/doctors.js";
import Navbar from '../navbar';


const { Text } = Typography;

const Counsellor = () => {
  const navigate = useNavigate();
  const [counsellors, setCounsellors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [saving, setSaving] = useState(false);
  
  // Form state
  const [formData, setFormData] = useState({
    name: '',
    profession: '',
    specialization: '',
    qualification: '',
    email: '',
    password: '',
    gender: '',
    experience: '',
    description: '',
    session_type: 'both',
    avatar: '',
    sequence: 0,
    rating: 0,
    smartflo_uid: '',
    smartflo_password: '',
    agent_number: '',
    caller_id: ''
  });
  
  
  // Success/error message state
  const [message, setMessage] = useState({ type: '', text: '' });
  
  // Accounts state
  const [accounts, setAccounts] = useState([]);
  const [accountsLoading, setAccountsLoading] = useState(false);

  const fetchCounsellors = async () => {
    setLoading(true);

    try {
      console.log("Fetching counsellors...");
      const response = await getAllDoctors();

      console.log("Fetched counsellors response:", response);
      console.log("Response success:", response.success);
      console.log("Response doctors:", response.doctors);
      console.log("Doctors count:", response.doctors?.length);

      if (response.success && response.doctors) {
        setCounsellors(response.doctors);
        console.log("Set counsellors state with:", response.doctors.length, "items");
      } else {
        setCounsellors([]);
        setError("Failed to load counsellors - Invalid response format");
      }

      setError(null);
    } catch (err) {
      console.error("Error in fetchCounsellors:", err);
      setError(err.message || "Failed to load counsellors");
      setCounsellors([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchAccounts = async () => {
    setAccountsLoading(true);
    try {
      const response = await getAllAccounts();
      console.log("Fetched accounts response:", response);
      if (response.success && response.accounts) {
        setAccounts(response.accounts);
        console.log("Set accounts state with:", response.accounts.length, "items");
      } else {
        setAccounts([]);
        console.log("Failed to load accounts or no accounts found");
      }
    } catch (err) {
      console.error("Error in fetchAccounts:", err);
      setAccounts([]);
    } finally {
      setAccountsLoading(false);
    }
  };

  useEffect(() => {
    fetchCounsellors();
    fetchAccounts();
  }, []);


  const handleAddCounsellor = () => {
    resetForm();
    setIsModalVisible(true);
  };

  const resetForm = () => {
    setFormData({
      name: '',
      profession: '',
      specialization: '',
      qualification: '',
      email: '',
      password: '',
      gender: '',
      experience: '',
      description: '',
      session_type: 'both',
      avatar: '',
      sequence: 0,
      rating: 0,
      smartflo_uid: '',
      smartflo_password: '',
      agent_number: '',
      caller_id: ''
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };


const handleSubmit = async (e) => {
  e.preventDefault();
  setSaving(true);

  try {
    const doctorData = {
      ...formData
    };

    const doctorRes = await createDoctor(doctorData);

    console.log("Created doctor:", doctorRes);

    if (!doctorRes.success || !doctorRes.doctor_id) {
      throw new Error("Doctor ID not returned from create doctor API");
    }

    setMessage({
      type: "success",
      text: "Counsellor created successfully",
    });

    setIsModalVisible(false);
    resetForm();
    fetchCounsellors();
  } catch (error) {
    console.error("Submit error:", error);

    setMessage({
      type: "error",
      text:
        error?.response?.data?.message ||
        error.message ||
        "Failed to create counsellor",
    });
  } finally {
    setSaving(false);
  }
};



  const filteredCounsellors = (counsellors || [])
    .filter((counsellor) => {
      const term = searchTerm.toLowerCase();
      return (
        counsellor.name?.toLowerCase().includes(term) ||
        counsellor.email?.toLowerCase().includes(term) ||
        counsellor.specialization?.toLowerCase().includes(term) ||
        counsellor.profession?.toLowerCase().includes(term) ||
        counsellor.qualification?.toLowerCase().includes(term)
      );
    })
    .sort((a, b) => a.sequence - b.sequence);

  console.log("Current counsellors state:", counsellors);
  console.log("Filtered counsellors:", filteredCounsellors);
  console.log("Loading state:", loading);
  console.log("Error state:", error);


  return (
    <>
      <Navbar />
      <div className="counsellors-container">
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 2,
          p: 0,
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column" ,ml:1}}>
          <Typography variant="h6" fontWeight={400} sx={{ color: "#1f2937"  ,mt:2}}>
            Counsellors
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          gap: 2,
          alignItems: "center",
          mb: 2,
          ml: 1,
          mt: 1,
          flexWrap: "wrap",
        }}
      >
        <TextField
          placeholder="Search counsellors"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{
            minWidth: { xs: 120, sm: 160, md: 200 },
            maxWidth: 800,
           
            flex: 1,
            "& .MuiOutlinedInput-root": {
              borderRadius: 0.5,
              bgcolor: "white",
              "& fieldset": { borderColor: "#d1d5db" },
              "&:hover fieldset": { borderColor: "#F59E0B" },
              "&.Mui-focused fieldset": { borderColor: "#F59E0B" },
              height: { xs: 36, sm: 40, md: 44 },
              fontSize: { xs: "0.8rem", sm: "0.875rem" },
              "& input": { py: { xs: 1, sm: 1 } },
            },
          }}
        />
      </Box>

      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
          <CircularProgress />
          <Typography variant="body1" sx={{ ml: 2 }}>Loading counsellors...</Typography>
        </Box>
      )}

      {error && (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
          <Typography variant="body1" color="error">{error}</Typography>
        </Box>
      )}

      {!loading && !error && (
        <TableContainer component={Paper} sx={{ mt: 2, mx: 2, maxWidth: 'calc(100% - 32px)', overflowX: 'hidden' }}>
          <MuiTable sx={{ minWidth: 650 }} size="small">
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "#4a90e2",
                  '& th': {
                    fontWeight: 600,
                    fontSize: "14px",
                    paddingTop: "14px",
                    paddingBottom: "14px",
                    color: "#fff",
                  },
                  height: 60,
                }}
              >
                <TableCell>Avatar</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>App Name</TableCell>
                <TableCell sx={{ width: 300, minWidth: 300, maxWidth: 300 }}>Profession</TableCell>
                <TableCell>Specialization</TableCell>
                <TableCell>Session Type</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredCounsellors.length > 0 ? (
                filteredCounsellors.map((counsellor) => (
                  <TableRow
                    key={counsellor.id}
                    sx={{
                      height: 'auto',
                      '& td': {
                        paddingTop: '12px',
                        paddingBottom: '12px',
                        verticalAlign: 'middle'
                      }
                    }}
                  >
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {counsellor.avatar ? (
                          <img
                            src={counsellor.avatar}
                            alt={counsellor.name}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = '/user.png';
                            }}
                            style={{
                              width: 40,
                              height: 40,
                              borderRadius: '50%',
                              objectFit: 'cover'
                            }}
                          />
                        ) : (
                          <img
                            src="/user.png"
                            alt={counsellor.name}
                            style={{
                              width: 40,
                              height: 40,
                              borderRadius: '50%',
                              objectFit: 'cover'
                            }}
                          />
                        )}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          {counsellor.name}
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <Typography variant="caption" sx={{ color: '#666', fontSize: '0.7rem' }}>
                            {counsellor.email || '-'}
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Typography variant="caption" sx={{ 
                            fontSize: '0.7rem',
                            color: counsellor.gender === 'Female' ? '#c2185b' : 
                                   counsellor.gender === 'Male' ? '#1976d2' : '#666'
                          }}>
                            {counsellor.gender || '-'}
                          </Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
                            <span style={{ fontSize: '12px' }}>⭐</span>
                            <span style={{ fontSize: '12px', color: '#666' }}>{counsellor.rating || '0'}</span>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Typography variant="caption" sx={{ color: '#666', fontSize: '0.7rem' }}>
                            {counsellor.experience ? `${counsellor.experience} exp` : '-'}
                          </Typography>
                          <Box sx={{
                            display: 'inline-block',
                            px: 0.5,
                            py: 0.25,
                            borderRadius: 0.5,
                            fontSize: '0.65rem',
                            fontWeight: 500,
                            backgroundColor: counsellor.status === 'available' ? '#e8f5e8' : '#ffeaa7',
                            color: counsellor.status === 'available' ? '#2d6a2d' : '#d63031'
                          }}>
                            {counsellor.status === 'available' ? 'Available' : counsellor.status || 'unknown'}
                          </Box>
                        </Box>
                      </Box>
                    </TableCell>
                    <TableCell>
                      {counsellor.app_name ? (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                          {counsellor.app_name.split(',').map((app, index) => (
                            <Chip
                              key={index}
                              label={app.trim().charAt(0).toUpperCase() + app.trim().slice(1)}
                              size="small"
                              sx={{
                                 display: 'inline-block',
                            px: 0.5,
                            py: 0.25,
                            borderRadius: 0.5,
                            fontSize: '0.65rem',
                            fontWeight: 500,
                                backgroundColor: '#e3f2fd',
                                color: '#1976d2'
                              }}
                            />
                          ))}
                        </Box>
                      ) : (
                        '-'
                      )}
                    </TableCell>
                    <TableCell sx={{ width: 300, minWidth: 300, maxWidth: 300 }}>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                        <Typography 
                          variant="body2" 
                          sx={{ 
                            fontWeight: 500,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                          }}
                        >
                          {counsellor.profession}
                        </Typography>
                        {counsellor.qualification && (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Typography 
                              variant="caption" 
                              sx={{ 
                                fontSize: '0.7rem', 
                                color: '#666',
                                lineHeight: 1.2
                              }}
                            >
                              {counsellor.qualification}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ maxWidth: 200 }}>
                        <Typography variant="body2" sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
                          {counsellor.specialization || '-'}
                        </Typography>
                        {counsellor.languages && (
                          <Box sx={{ mt: 0.5 }}>
                            <Typography variant="caption" sx={{ 
                              fontSize: '0.7rem', 
                              color: '#666',
                              lineHeight: 1.2,
                              mb: 0.5
                            }}>
                              Pref. Languages:
                            </Typography>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.3 }}>
                              {counsellor.languages.split(',').filter(lang => lang.trim()).map((lang, index) => (
                                <Chip
                                  key={index}
                                  label={lang.trim().charAt(0).toUpperCase() + lang.trim().slice(1)}
                                  size="small"
                                  sx={{
                                    display: 'inline-block',
                                    px: 0.3,
                                    py: 0.1,
                                    borderRadius: 0.3,
                                    fontSize: '0.6rem',
                                    fontWeight: 500,
                                    backgroundColor: '#f3e5f5',
                                    color: '#7b1fa2',
                                    height: 'auto',
                                    minHeight: '16px'
                                  }}
                                />
                              ))}
                            </Box>
                          </Box>
                        )}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box sx={{
                        display: 'inline-block',
                        px: 1,
                        py: 0.5,
                        borderRadius: 0.5,
                        fontSize: '0.75rem',
                        fontWeight: 500,
                        backgroundColor: counsellor.session_type === 'in_person' ? '#e8f5e8' : '#fff3e0',
                        color: counsellor.session_type === 'in_person' ? '#2d6a2d' : '#e65100'
                      }}>
                        {counsellor.session_type === 'both' ? 'Both' :
                          counsellor.session_type === 'in_person' ? 'In Person' :
                            counsellor.session_type || '-'}
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                      <Typography variant="body1" color="text.secondary">
                        No counsellors found
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </MuiTable>
        </TableContainer>
      )}


      {/* Add/Edit Counsellor Modal */}
      <Dialog 
        open={isModalVisible} 
        onClose={() => setIsModalVisible(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: { overflow: 'hidden' }
        }}
      >
        <DialogTitle>
          Add New Counsellor
        </DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent 
            sx={{ 
              maxHeight: '70vh',
              overflow: 'auto',
              '&::-webkit-scrollbar': { display: 'none' },
              scrollbarWidth: 'none',
              msOverflowStyle: 'none'
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
              {/* Basic Information */}
              <Typography variant="subtitle1" fontWeight={600}>Basic Information</Typography>
              
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <TextField
                  name="name"
                  label="Name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  sx={{ flex: 1, minWidth: 200 }}
                />
                <TextField
                  name="email"
                  label="Email"
                  type="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  sx={{ flex: 1, minWidth: 200 }}
                />
              </Box>

              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <TextField
                  name="password"
                  label="Password"
                  type="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  required
                  sx={{ flex: 1, minWidth: 200 }}
                />
                <FormControl sx={{ flex: 1, minWidth: 200 }}>
                  <InputLabel>Gender</InputLabel>
                  <Select
                    name="gender"
                    value={formData.gender}
                    onChange={handleInputChange}
                    label="Gender"
                  >
                    <MenuItem value="Male">Male</MenuItem>
                    <MenuItem value="Female">Female</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                </FormControl>
              </Box>

              {/* Professional Information */}
              <Typography variant="subtitle1" fontWeight={600}>Professional Information</Typography>
              
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <TextField
                  name="profession"
                  label="Profession"
                  value={formData.profession}
                  onChange={handleInputChange}
                  required
                  sx={{ flex: 1, minWidth: 200 }}
                />
                <TextField
                  name="specialization"
                  label="Specialization"
                  value={formData.specialization}
                  onChange={handleInputChange}
                  sx={{ flex: 1, minWidth: 200 }}
                />
              </Box>

              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <TextField
                  name="qualification"
                  label="Qualification"
                  value={formData.qualification}
                  onChange={handleInputChange}
                  sx={{ flex: 1, minWidth: 200 }}
                />
                <TextField
                  name="experience"
                  label="Experience (years)"
                  value={formData.experience}
                  onChange={handleInputChange}
                  sx={{ flex: 1, minWidth: 200 }}
                />
              </Box>

              <TextField
                name="description"
                label="Description"
                multiline
                rows={3}
                value={formData.description}
                onChange={handleInputChange}
                fullWidth
              />

              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <FormControl sx={{ flex: 1, minWidth: 200 }}>
                  <InputLabel>Session Type</InputLabel>
                  <Select
                    name="session_type"
                    value={formData.session_type}
                    onChange={handleInputChange}
                    label="Session Type"
                  >
                    <MenuItem value="video">Video</MenuItem>
                    <MenuItem value="in_person">Audio</MenuItem>
                    <MenuItem value="both">Both</MenuItem>
                  </Select>
                </FormControl>
                <TextField
                  name="avatar"
                  label="Avatar URL"
                  value={formData.avatar}
                  onChange={handleInputChange}
                  sx={{ flex: 1, minWidth: 200 }}
                />
              </Box>


              {/* Technical Information */}
              <Typography variant="subtitle1" fontWeight={600}>Technical Information</Typography>
              
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <TextField
                  name="smartflo_uid"
                  label="SmartFlo UID"
                  value={formData.smartflo_uid}
                  onChange={handleInputChange}
                  sx={{ flex: 1, minWidth: 200 }}
                />
                <TextField
                  name="smartflo_password"
                  label="SmartFlo Password"
                  type="password"
                  value={formData.smartflo_password}
                  onChange={handleInputChange}
                  sx={{ flex: 1, minWidth: 200 }}
                />
              </Box>

              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <TextField
                  name="agent_number"
                  label="Agent Number"
                  value={formData.agent_number}
                  onChange={handleInputChange}
                  sx={{ flex: 1, minWidth: 200 }}
                />
                <TextField
                  name="caller_id"
                  label="Caller ID"
                  value={formData.caller_id}
                  onChange={handleInputChange}
                  sx={{ flex: 1, minWidth: 200 }}
                />
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setIsModalVisible(false)}>Cancel</Button>
            <Button 
              type="submit" 
              variant="contained" 
              disabled={saving}
              startIcon={saving ? <CircularProgress size={20} /> : null}
            >
              {saving ? 'Saving...' : 'Save Counsellor'}
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* Success/Error Message Snackbar */}
      <Snackbar 
        open={!!message.text} 
        autoHideDuration={6000} 
        onClose={() => setMessage({ type: '', text: '' })}
      >
        <Alert 
          onClose={() => setMessage({ type: '', text: '' })} 
          severity={message.type} 
          sx={{ width: '100%' }}
        >
          {message.text}
        </Alert>
      </Snackbar>

      </div>
    </>
  );
};

export default Counsellor;